export const Technology = [
  {
    id: 1,
    title: "sos",
    handle: "/technology/sos",
    image: "https://d3leeb4r1qy96s.cloudfront.net/pages/Technology_1_Sos_Lab.jpg",
    youtube:
      '<iframe width="100%" height="490" src="https://www.youtube.com/embed/--I4ehPRPGo?wmode=transparent" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>',
    content: `### S·O·S үйлчилгээ гэж юу вэ?

![](http://webnew.barloworld.mn/images/uploads2/2020-09-18-09-30-40wae__L7A3652.JPG)

S·O·S үйлчилгээ гэдэг нь тос болон хөргөлтийн шингэнд хийгдэх лабораторийн шинжилгээ юм. Шинжилгээний хариу дээжийг хүлээн авснаас хойш 1-3 өдрийн дотор бэлэн болдог ба манай шинжилгээний 95% нь 24 цагийн дотор харилцагчид хүрдэг. **Хурд хамгийн чухал бөгөөд цаг хугацаа алдах нь өртөг өндөртэй байдгийг бид мэднэ.** Шинжилгээний дээж S·O·S лабораторид ирснээр, дээж бүрт цогц шинжилгээг хийх ба дэлхийн хамгийн орчин үеийн дэвшилтэт технологиор шинжилгээг гүйцэтгэдэг. Мэргэшсэн ажилтнууд шинжилгээг гүйцэтгэж, 30 гаруй жилийн туршлагатай аналист тайлбар зөвлөмж өгдөг ба таны асуултанд хариулах, шинжилгээний хариуны талаар нарийвчлан ярихад бид хэзээд бэлэн байх болно.

  

### S·O·S үйлчилгээний харилцагчид очих ашиг тус

![](http://webnew.barloworld.mn/images/uploads2/2020-09-18-09-30-27wae__L7A2047.JPG)

Харилцагч S·O·S үйлчилгээнд оруулсан 1$ тутамдаа 15$-60$ хэмнэдэг ба S·O·S үйлчилгээг ашигласнаар Та дараах давуу талуудыг авах болно.

*   **Эвдрэлийг эрт илрүүлнэ** томоохон эвдрэл үүсэхээс өмнө засварлах боломж олгодоно
*   **Сөрөг муу хариунаас гадна эерэг сайныг танихад хэрэглэгдэнэ** ингэснээр, эвдрээгүй эд ангийн засварт мөнгө төлөх шаардлагагүй болно;
*   **Сул зогсолтыг төлөвлөх боломж олгоно** ямар эд анги муудсан, хэзээ элэгдэх зэрэг ажлын ачаалалд тохируулан засвар үйлчилгээг зөв төлөвлөж чадна
*   **Засварын төлөвлөлтийг хянахад тань туслана** төлөвлөгөөт ажлыг гүйцэтгэсэн эсэхийг хянах боломж олгоно
*   **Төсвийг илүү сайн удирдах боломжийг олгоно** эвдрэл гэмтэл болон сул зогсолтыг багцаалснаар хэзээ, ямар хэмжээтэй зардал гарах болон хамгийн өндөр бүтээлтэй хэрэгцээт машинуудад засвар үйлчилгээг төлөвлөх боломжийг олгоно
*   **Тосны ашиглалтыг хугацааг уртасгана** тосыг тодорхой интервалаар солихын оронд тухайн тосны төлөв байдалд үндэслэн тосыг солих бололцоог олгоно

  
  
  

### S·O·S тосны шинжилгээ

![](http://webnew.barloworld.mn/images/uploads2/2020-09-18-09-30-47wae_C033805.jpg)

**Элементийн шинжилгээ**гээр тосонд 10 микрон болон түүнээс бага хэмжээтэй ямар метал хэр хэмжээгээр агуулагдаж байгаа тогтооно. Дээжнээс дээжинд ямар металл ихсэж байгааг хянах нь тоон үзүүлэлтийг хянахтай адил чухал юм. Иймээс тосоор тослогддог эд анги бүрт металлын элэгдлийн хэмжээг тогтоох тулд тодорхой интервалаар дээж авах шаардлагатай болдог. Элементийн шинжилгээгээр элэгдлийн үзүүлэлтээс гадна бохирдлыг бас тодорхойлно.  
**Тунгалаг чанарын шинжилгээг** гидравликийн болон хүч дамжуулах ангиас авсан тосонд жижиг хэсэг тоологч багажаар гүйцэтгэдэг. Энэ шинжилгээгээр элэгдлээс үүсэх метал болон металл биш үртэсийг тоолохоос гадна гаднаас систем рүү нэвтэрсэн бохирдлыг тоолно. Элементийн болон тунгалаг чанарын шинжилгээний мэдээллийг цуглуулснаар гидравлик болон хүч дамжуулах системийн талаар илүү оновчтой тайлбар зөвлөмж өгдөг. Эдгээр шинжилгээг хослуулан хэрэглэснээр элементийн шинжилгээгээр таних боломжгүй эвдрэлийг илрүүлэх боломжтой нээгддэг.  
**Тосны төлөв байдлын шинжилгээ**гээр тосны тослох чанарын алдагдлыг тодорхойлох ба нил улаан туяаны багажаар шинжилгээг хийнэ. Энэ шинжилгээгээр хэрэглээний явцад тос чанараа алдсан эсэхийг мөн тосны ашиглалтын хугацаанд үзүүлэлтдээ тохирсон ажил гүйцэтгэсэн эсэхийг тодорхойлно.   
**Түлш, ус, гликолыг тодорхойлох:**Тосонд түлш, ус, гликол илрэх нь яаралтай засварын ажлыг эхлүүлэх эвдрэл системд явагдаж байгааг илэрхийлдэг. Тос түлшээр бохирдвол зууралдлага нь буурч, тослох чанараа алддаг. Шаталтанд ороогүй түлш кольцийг даган урсаж тахир гол руу орсноос эсвэл хүйтний улиралд хэт удаан нормальдах нь түлшний бохирдлыг үүсгэдэг. Түлшний бохирдол нь ашигласан тосны эзэлхүүний 4%-иас ихсэхэд, вкладш элэгдэж, кольц гацах үндсэн шалтгаан болно. Хөргөлтийн шингэн нь тосыг маш хурдан исэлдүүлэх ба яаралтай засварлах арга хэмжээ авахгүй бол томоохон эвдрэлийн шалтгаан болдог. Хэт халалтын улмаас конденсац үүсэх эсвэл, ус систем рүү орсноор тос усаар бохирддог. Усны бохирдол нь шүүлтүүрийг бөглөрүүлэх ба эд ангийн насжилтийг багасгах эсвэл гэнэтийн эвдрэлд хүргэнэ.  
**Нэмэлт шинжилгээнүүд** PQI- Mеталлын шинжилгээнд хэрэглэгддэг лабораторийн бүх төрлийн багаж нь 10 микроноос дээш хэмжээтэй жижиг хэсгийн тухай мэдээллийг өгөх боломжгүй байдаг. Тэгвэл энэ дутагдалтай талыг нөхөх зорилгоор PQI шинжилгээг та бүхэнд санал болгож байна. PQI шинжилгээ нь тухайн тосны дээжинд агуулагдах нийт соронзлогддог материалуудын тоо ширхгийг мэдээллэнэ. Хэрвээ төмрөн эд ангид (ихэнхи эд анги төмрөөр хийгддэг) эвдрэл явагдаж байвал, металлын шинжилгээний үзүүлэлт хэвийн гарсан ч, PQI шинжилгээний утга өндөр гардаг . Машин тоног төхөөрөмжийнхөө ашиглалтын хугацааг хамгийн дээд хэмжээгээр уртасгахад тань туслах зорилгоор PQI шинжилгээг хөдөлгүүрийн болон захын дамжуулагчийн дээжинд хийлгэхийг бид зөвлөдөг. PQI шинжилгээг бүх төрлийн тосонд буюу тортогтой, тортоггүй  
ямар ч дээжинд хийж болдгоороо давуу талтай. Бодит, нарийвчлалтай үр дүнг PQI шинжилгээнээс авахын тулд дээжийг халуун байхад нь авах шаардлагатай. **Нийт суурийн тоо (НСТ)**\- Түлшинд агуулагдах хүхрээс үүсэх хүчлүүд нь тосны чанарыг муутгаж, эд ангийг зэврээдэг. Хөдөлгүүрийн тос нь хүчлийг тодорхой хэмжээгээр саармагжуулах чадвартай байдаг бөгөөд энэ үзүүлэлтийг шалгах зорилгоор нийт суурийн тоо шинжилгээг хөдөлгүүрийн тосонд хийдэг. Монгол улсад худалдаалагдаж байгаа түлшинд хүхрийн агуулга өндөр, хэрэглэгдэж байгаа тосны чанар муу зэргээс шалтгаалж нийт суурийн тоо шинжилгээг хөдөлгүүрийн тосон дээр байнга хийлгэхийг би зөвлөж байна. Мөн энэ шинжилгээний үр дүн нь тосны ашиглалтын зохимжит интервалыг тогтоох ажиллагааны нэгэн чухал хэмжигдэхүүн болон хэрэглэгддэг.  
**Нийт хүчлийн тоо (НХТ)**\- Хөдөлгүүрийн тос солих интервалыг ихэсгэх болон гидравлик тосыг солих хугацааг Катерпилларын зөвлөсний дагуу 4000 цаг хүртэл уртасгах зорилгоор нийт хүчлийн тоо шинжилгээг хийдэг.  

  
  
  

### S·O·S Хөргөлтийн шингэний шинжилгээ

![](http://webnew.barloworld.mn/images/uploads2/2020-09-18-09-30-52wae_Coolant_copy.JPG)

Хөдөлгүүрийн эвдрэлийн 50% орчим нь хөргөлтийн системтэй холбоотой байдаг. Үүнээс улбаалан, caterpillar нь S×O×S хөргөлтийн шингэний шинжилгээг бий болгосон ба тус шинжилгээг бүх төрлийн хөргөлтийн системийн хөргөлтийн шингэнд хийлгэхийг зөвлөдөг. Дизель хөдөлгүүр нь жижиг тэрэг болон бага оврын ачааны машины хөдөлгүүрээс илүү өндөр температур, илүү өндөр даралтын дор ажилладаг тул түүнд ашиглах хөргөлтийн шингэнд мөн адил өндөр шаардлага тавигддаг байна. Ялангуяа caterpillar-ын бүтээгдэхүүнүүд нь хөдөлгүүр, хүч дамжуулах анги болон гидравликийн тосноос дулааныг шингээх хөргөлтийн системд тулгуурласан хийцтэй. Үүнээс гадна, ашигласан хөргөлтийн шингэнийг солих нь илүү хатуу чанд бөгөөд өртөг өндөртэй болсоор байна. Ашигласан хөргөлтийн шингэнийг асгахдаа холбогдох хуулийг мөрдөх ёстой. SOS шингэний шинжилгээний лабораторийн үйлчлүүлэгчид нь хөргөлтийн шингэнийг солих хугацааг уртасгах боломжтой учраас байгаль орчиндоо ээлтэй ханддаг. Дээрх бүхнээс үзэхэд, өнөөгийн машин болон хөдөлгүүрийг хамгийн ашигтай ажиллуулахын тулд SOS хөргөлтийн шингэний шинжилгээг хийлгэвэл зохимжтой.

##### Cтандарт багц

Ph  
Цахилгаан дамжуулах чанар  
Гликолын түвшин  
Хөлдөх болон буцлах температур  
Нитритийн түвшин  
Молигийн түвшин  
Харааны шинжилгээ: өнгө, үнэр, хөөсрөлт, тунадас  
Дэлгэрэнгүй мэдээлэл авахыг хүсвэл: soslab@barloworld.mn болон 976-7575-6090 утас руу холбогдоорой.

  
  
  

### Cat® S·O·S үйлчилгээг сонгох 6 шалтгаан

![](http://webnew.barloworld.mn/images/uploads2/2020-09-18-09-30-34wae__L7A2084.jpg)

Хэрвээ та машины тосоо шинжлүүлдэггүй эсвэл өөр лабораториор үйлчлүүлдэг бол Cat® S·O·S үйлчилгээг сонгох 6 шалтгааныг нэрлэе.  
  
ИТГЭЖ БОЛОХ ҮР ДҮН  
S·O·Sүйлчилгээг Катерпилларын эрдэмтэн судлаачид бүтээж, машин техникийн инженерүүд тогтмол хөгжүүлдэг. Бид олон улсын шинжилгээний стандартыг дагаж мөрддөг ба үнэн зөв, өндөр нарийвчлалтай үр дүнг харилцагчиддаа хүргэдэг.  
  
МАШИНЫ ЭЛЭГДЛИЙН ЧИГ ХАНДЛАГЫН ТАЛААРХ БОДИТ ТААМАГЛАЛ  
Машин техникийн онцлог, тос болон хөргөлтийн шингэний шинж чанарын талаарх сая сая мэдээлэл дээр үндэслэн, дээжийг үнэлж, тайлбар зөвлөмж өгдөг. Жил тутамд 7 сая гариу дээж дэлхий даяар тархан байрласан SOS лабораториудаар шинжлэгддэг байна.  
  
ҮР АШИГТАЙ АЖИЛЛАХАД ТАНЬ ТУСЛАНА  
CAT дилер нь тоног төхөөрөмжийн менежментийн хөтөлбөр болон шаардлагад тань нийцүүлэн дээж авах хуваарийг тодорхойлж өгнө. Томоохон эвдрэлээс урьдчилан сэргийлж хэмнэлт хийхээс гадна үйл ажиллагаагаа оновчлоноор , зардлыг багасгана.  
  
ТЕХНИКИЙН НӨХЦӨЛ БАЙДЛЫН ТАЛААРХИ ЦОГЦ МЭДЛЭГ  
Тос болон хөргөлтийн шингэний шинжилгээний үр дүнг Condition monitoring-н бусад элементүүдтэй нэгтгэснээр тухайн тоног төхөөрөмжийн эрүүл мэнд, хэвийн ажиллагаа, гүйцэтгэл, байршилийн талаарх цогц мэдээллийг таньд өгнө. (дэлхийг хамарсан программ хангамж, Катерпилларын аль ч дилерт хандсан таны шинжилгээний түүх тасрахгүй үргэлжлэх болно)  
  
ХОЛИМОГ БААЗТАЙ ЮУ? ТЭГВЭЛ БИДЭНД ХАНДААРАЙ  
CАТ эсвэл бусад машин үйлдвэрлэгчээс үл хамаарч хөдөлгүүр болон машины талаар манай багийнхан хэнээс ч илүү мэдлэгтэй. Дэлхий дээр тархан байрласан S·O·S лабораториудад шинжлэгддэг дээжний 25%-ийг САТ бус техникээс авсан байдаг. Тиймээс холимог баазад тохирох хамгийн зөв шийдэл нь S·O·S үйлчилгээ юм.  
  
БҮХ ТӨРЛИЙН ТОС, ХӨРГӨЛТИЙН ШИНГЭНИЙГ ШИНЖИЛНЭ  
SOS лаборатори нь генератороос авхуулаад дамжуулах хоолой, уул уурхайн хүнд даацын техник, усан онгоц гэх мэт бүх төрлийн машин тоног төхөөрөмжийн бүх төрлийн тос болон хөргөлтийн шингэнийг шинжилдэг.`,
  },
  {
    id: 2,
    title: "miningt",
    handle: "/technology/miningt",
    image: "https://d3leeb4r1qy96s.cloudfront.net/pages/Technology_2_Mining_tech.jpg",
    youtube:
      '<iframe width="100%" height="490" src="https://www.youtube.com/embed/1UEJcy20q-8?wmode=transparent" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>',
    content: `### Уул уурхайн технологи

![](http://webnew.barloworld.mn/images/uploads2/2020-09-18-01-27-03wae_Picture1.jpg)  

Бид Катерпилларын CAT® Product Link™ – Машин тоног төхөөрөмжийг алсаас шууд хянах баазын менежментийн систем, CAT® Minestar™ – Уул уурхайн автоматжуулалтын систем, CAT® Driver Safety System – Операторын ядарсаныг мэдрэх аюулгүй ажиллагааны систем , CAT® Simulators, CAT® EMS®, CAT®360° ADVANTAGE зэрэг тоног төхөөрөмжийн ашиглалтын зардлыг бууруулах менежментийн шийдлүүдийг Катерпилларын олон улсын стандартын дагуу нийлүүлдэг. Эдгээр технологийн шийдлүүд нь уурхайн үйл ажиллагаанд оролцож байгаа техник, хүн, ажлын процессийг хооронд нь холбож хамгийн үр бүтээмжтэй, аюулгүй ажиллахад тусална.  
  
  

#### Cat® MineStar ™

  
Cat® MineStar ™ нь уул уурхайн салбарын хамгийн өргөн цар хүрээтэй, иж бүрэн технологийг санал болгодог багц юм. MineStar нь Дэлхийн өнцөг булан бүрт олон жилийн турш үр дүнгээ өгсөөр байна. Уурхайн олборлолтын хэлбэр нь ил хэлбэрээс далд хэлбэрт шилжихийн хэрээр Катерпиллар нь олон арван жил хийж ирсэн дэмжих үйлчилгээгээ сайжруулах үүднээс технологийн багцуудыг өргөжүүлэн хөгжүүлж эхэлсэн. Уурхайд аюулгүй, үр ашигтай ажиллахад томоохон бэрхшээл тулгардаг. MineStar нь өдөр бүр тохиодох бэрхшээлүүдийг даван туулахаар боловсруулагдсан. Гол үр ашиг нь Зардлыг хянах. Тоног төхөөрөмжийн ашиглалтын хугацааг уртасгах. Илүү үр бүтээлтэй ажиллах. Хүмүүсийн аюулгүй байдлыг хангах ажлуудыг бүх түвшинд гүйцэтгэж чаддаг автоматжуулалтын систем юм.  

![](http://webnew.barloworld.mn/images/uploads2/2020-09-18-01-27-13wae_Picture3.jpg)

**Fleet**  
Fleet нь машиныг цаг тухайд нь хянах, даалгавар өгөх, бүтээмжийн менежментийг цогц байдлаар хангаж, дэлхийн хаанаас ч явагдаж буй бүх үйл ажиллагааны тоймыг танд өгдөг диспетчерийн хяналтын систем юм.

![](http://webnew.barloworld.mn/images/uploads2/2020-09-18-01-27-16wae_Picture4.jpg)

**Terrain**  
Terrain нь технологийн зааварчилгааг шууд ашиглан өрөмдлөгө, хөрс хуулалт, ачилтын үйл ажиллагааг нарийн тодорхойлогдсон удирдлагаар хангадаг хагас автоматжуулсан технологи. Ингэсэнээр машинуудын бүтээмж болоод бодит үр ашиг хурдан хугацаанд нэмэгддэг.

![](http://webnew.barloworld.mn/images/uploads2/2020-09-18-01-27-20wae_Picture5.jpg)

**Detect**  
Detect нь операторын мэдлэгийг дээшлүүлэх болон үйл аюулгүй ажиллагааг хангахад тусалдаг. Өөрөөр хэлбэл операторт туслах зорилготой хар цэг тодорхойлох, камер, радар гэх мэт бусад аюул ослыг мэдрэх, урьдчилан сэргийлэх хөдөлгөөнт болон суурин тоног төхөөрөмж, программ хангамж ашиглан аюулгүй ажиллагааг хангадаг систем юм.

  
![](http://webnew.barloworld.mn/images/uploads2/2020-09-18-01-27-25wae_Picture6.jpg)  
  
  

![](http://webnew.barloworld.mn/images/uploads2/2020-09-18-01-27-33wae_Picture7.jpg)

**Health**  
Health нь машинуудын ашиглалт, эвдрэл гэмтэл, бусад чухал мэдээллүүдийг өгдөг. Өөрөөр хэлбэл тоног төхөөрөмжүүдийн төлөв, оношилгоо, ашиглалтын тайланг нэгтгэсэн цогц хяналтын систем юм.

![](http://webnew.barloworld.mn/images/uploads2/2020-09-18-01-27-40wae_Picture8.jpg)

**Command**  
Command нь ил болон далд уурхайн тоног төхөөрөмжүүдийг зайнаас удирдах хагас болон бүрэн автомат автоматжуулалтын систем. Fleet, Terrain, Detect болон Health-ийн технологийн чадамжуудыг нэгтгэн таны олборлолтын аюулгүй ажиллагаа, бүтээмжийг эр нэмэгдүүлдэг.

![](http://webnew.barloworld.mn/images/uploads2/2020-09-18-01-27-46wae_Picture9.jpg)  
  
  
  

### Cat® Inspect

![](http://webnew.barloworld.mn/images/uploads2/2020-09-22-03-24-25wae_Cat_inspect.jpg)  

Цаастай зууралдахаас залхаж байна уу? CAT® Inspect-г ухаалаг утсандаа татаж аваарай !  
  
_Энэхүү аппликейшн нь утсандаа татаж суулгахад ямар ч үнэ төлбөргүй.Apple-н төхөөрөмжүүдэд iOS7 болон түүнээс дээш хувилбарт болон Андройд төхөөрөмжүүдэд Jelly Bean 4.1 болон түүнээс дээш хувилбарууд суух боломжтой_  
  
Cat® Inspect нь Cat болон бусад Cat бус техникүүдэд зориулсан урьдчилсан үзлэг шалгалтыг хийхээс гадна зураг оруулж , тайлбар, үнэлгээ өгч болдог хэрэглэхэд хялбар аппликешин юм.  
Хяналт шалгалтын маягтанд урьдчилан сэргийлэх засвар үйлчилгээний хяналтын хуудас,  
Техникийн анализын маягт (TA-1), Өдөр тутмын аюулгүй байдлын тойрох үзлэг гэх мэт орно.  
Та өөрийн Cat дилертэйгээ холбогдож мэдээлэл аваарай.  

Та Android үйдлийн аппликейшн татах бол [энд](https://apkpure.com/cat%C2%AE-inspect/com.cat.desd.mobile.inspect/download?from=developer) дарна уу. ![](http://webnew.barloworld.mn/images/uploads2/2020-09-22-03-03-29wae_and_ins.png) 

Та IOS үйдлийн аппликейшн татах бол [энд](https://apps.apple.com/mn/app/cat-inspect/id1364673170?fbclid=IwAR0hdjvEZvOibX6sfMpdfZs31kLp2Zt5haV5x40YRgMH5coFzLjevSzXyec) дарна уу. ![](http://webnew.barloworld.mn/images/uploads2/2020-09-22-03-03-36wae_iso_ins.png) 

### Cat® App: Баазын Менежмент

![](http://webnew.barloworld.mn/images/uploads2/2020-09-22-03-24-21wae_Cat_app_fleet_management.jpg)  

Cat® аппликешины тусламжтайгаар тоног төхөөрөмжөө хамгийн үр ашигтай удирдаж эхэлнэ.  
Техникийнхээ байрлал болон ашиглалт, эрүүл мэндийг хянаж, сэлбэг хэрэгсэлээ захиалахад хэдхэн товчин дээр дарахад л хангалттай. Техник тоног төхөөрөмжөө бүрэн хяналтдаа байлгах нь одоо хялбар болсон.  
  
**ДАТА БҮХНИЙГ ЭНГИЙН БОЛГОНО.**  
Техник бүрийнхээ GPS байрлал, мото цаг, ашиглалт, шатахууны хэмжээг харах боломжтой. Нэг дор танд хэрэгтэй бүх мэдээлэл байгаа.  
  
**БҮХНИЙГ ХЯНАЛТДАА БАЙЛГАНА.**  
Ухаалаг утсан дээрээ автоматаар мэдэгдэл хүлээн авснаар анхаарах хэрэгтэй техникээ мэдэж, ажиллах цагаа ихэсгэж, техник тоног төхөөрөмжийн бааздаа юу болж байгааг үргэлж хянах боломжтой.  
  
**ТЕХНИКИЙНХЭЭ ЭРҮҮЛ МЭНДИЙГ ХЯНАСАНААР БҮХНИЙГ ХЯЛБАР БОЛГО.**  
Ганцхан товчоор л та өөрийн дилерт засвар үйлчилгээний хүсэлт илгээж, Алдааны код хүлээн авч, сэлбэг хэрэгсэлээ захиалах боломжтой. Машиныхаа эрүүл мэндийг хурдан шуурхай, хялбараар хянаарай.  
  
Онцлог шинжүүд:  
• GPS-н тусламжтай тоног төхөөрөмжийнхөө байрлалыг хянах  
• Телематикуудыг хянах (Мото цаг, Ашиглалт, Шатахууны хэмжээ, Алдааны код)  
• Ухаалаг утсан дээрээ анхаарах хэрэгтэй тоног төхөөрөмжийн тухай мэдэгдэл хүлээн авах  
• Өөрийн Cat® дилерт засвар үйлчилгээний хүсэлт илгээх  
• Хэрэгцээт сэлбэг хэрэгсэлээ хайх, захиалах  
Cat® аппликешинээ яг одоо татаад техник тоног төхөөрөмжийнхөө баазыг дараагийн түвшинд хүргээрэй.  

Та Android үйдлийн аппликейшн татах бол [энд](https://apkpure.com/cat%C2%AE-app-fleet-management/com.cat.corelink/download?from=developer) дарна уу. ![](http://webnew.barloworld.mn/images/uploads2/2020-09-22-03-03-46wae_and_fle.png) 

Та IOS үйдлийн аппликейшн татах бол [энд](https://apps.apple.com/mn/app/cat-app-fleet-management/id1258931644?fbclid=IwAR2bSJ90ZBM22i-CTWeHAwyirciCiEMcGwxEjyk7MMFxLhezkazyKZWWNpk) дарна уу. ![](http://webnew.barloworld.mn/images/uploads2/2020-09-22-03-14-14wae_last.png) 

### Жолоочийн аюулгүй ажиллагааны систем

##### ОПЕРАТОРЫН АНХААРАЛ САРНИХ, ЯДАРЧ ЗҮҮРМЭГЛЭХ ҮЕД ДАРУЙ СЭРЭМЖЛҮҮЛЭХ ДОХИОЛОЛ

Анхаарал сарних, ядарч сульдах явдал уурхайн ажлын талбайд өдөр бүр тохиолддог ба амь насанд аюул учруулж болох эрсдэлийг дагуулдаг. Үүнийг зогсоохын тулд ядарч сульдах эсвэл анхаарал сарних мөчид операторыг сэрэмжлүүлж дуут дохио өгдөг технологийн дэвшилтэт системийг ашигладаг болно.

Жолоочийн аюулгүй ажиллагааны систем нь аюултай нөхцөл байдлыг газар дээр нь төвөг чирэгдэлгүй шийдэж чадна. Энэхүү систем зөвхөн машин дотор ажиллахаас гадна CATERPILLAR-ийн 7 хоногийн 24 цагийн турш ажилладаг мэргэжлийн багийнханд ашиглалтын үеийн ядралт, анхаарал сарних байдлуудыг бүрэн харж мэдэх боломжийг олгоно.

##### БҮРТГЭГДСЭН ЗӨРЧЛИЙГ ДАРУЙ БАГАСГАЖ, ЭРСДЭЛИЙГ ТАСРАЛТГҮЙ УДИРДАН ЗОХИЦУУЛ

  
  

**МАШИН ДОТОРХ АЖИЛЛАГАА**  
\- Ядралт болон анхаарал сарнилтыг нүдний цавчих хөдөлгөөн, толгойн байрлалаар хянана;  
\- Зөрчил бүртгэгдэх үед нүүрний болон зөвхөн нүдний видео бичлэг хийгдэнэ;  
\- Хурд хэтрэх болон бусад бүртгэгдсэн зөрчлүүдийг олж тогтооно;  
\- Тохируулж болохуйц чичиргээний болон дуут дохиолол кабин дотор байрладаг;  
Өөрчлөн тохируулах боломжтой параметрүүдтэй.  
  
[Брошюр үзэх](https://www.barloworld.mn/uploads/Technology/DSS_Brochure.pdf)  

  

**БҮРТГЭГДСЭН ЗӨРЧЛИЙГ ХЯНАЖ, МЭДЭЭЛЖ, ШИНЖЛЭХ**  
\-Бүртгэгдсэн зөрчлийг 24 цагийн турш хянаж, ангилан боловсруулна;  
\-Сайтын түвшний зөвлөмжийн дагуу мэдээлж, дүн шинжилгээ хийнэ;  
\-Сургалтын болон оператор бэлтгэх мөн мэдлэг олгох материалууд;  
\-Жолоочийн ядралт ба анхаарал сарнилтын бүртгэгдсэн зөрчлүүдийг;  
\-Тоног төхөөрөмжийн өгөгдлийн сантай харьцуулан үнэлнэ;  
\-Ядралтыг бууруулах төлөвлөгөөг боловсруулах боломж бүрдэнэ;  
\-DSS-ийн эд ангиудын хэвийн ажиллагааг идэвхитэй хянана;  
\-Өөрчлөн тохируулах боломжтой параметрүүд.  
  

![](	http://webnew.barloworld.mn/images/uploads2/2020-12-15-05-22-06wae_Picture4.jpg)  

![](http://webnew.barloworld.mn/images/uploads2/2020-12-15-05-22-12wae_Picture3.jpg)

  
  

**БҮРТГЭГДСЭН ЗӨРЧЛИЙГ ХЯНАЖ, МЭДЭЭЛЖ, ШИНЖЛЭХ**  
\- Ядралтыг хянан зохицуулах төлөвлөгөөг нягтлах, боловсронгуй болгоно;  
\- Ажилчдыг эрсдэлээс хамгаалах хамгаалалтыг олон үе давхаргыг бий болгоно;  
\- Өөрчлөлтийн менежментийн талаар зөвлөгөө өгнө  

![](http://webnew.barloworld.mn/images/uploads2/2020-12-15-05-34-23wae_Picture5.jpg)

  
  

**АЖИГЛА**

Эрсдэлийн одоогийн түвшнийг олж харахын тулд бүртгэгдсэн зөрчлүүдийг хянана;

  
**БАГАСГА**

Ядрах, анхаарал сарних зөрчлүүд бүртгэгдэхэд операторын бодит байдлын дохиолол (суудлын чичиргээ, дуут дохио) ажиллана;

  
**ЗОХИЦУУЛ**

Ажилчдыг эрсдэлээс хамгаалах хамгаалалтын олон үе давхаргыг бий болгохын тулд ядралтын эрсдэлийн менежментийн төлөвлөгөө боловсруулна.

  

![](http://webnew.barloworld.mn/images/uploads2/2020-12-15-05-39-00wae_Picture6.png)

![](http://webnew.barloworld.mn/images/uploads2/2020-12-15-05-39-05wae_Picture7.png)

  

##### МЕНЕЖЕРҮҮДЭД ЗОРИУЛСАН САЙТ ДЭЭРХ СУРГАЛТ СЕМИНАР

DSS бол Катерпиллараас гаргасан эрсдэлийн менежментийн иж бүрэн шийдлийн нэг хэсэг бөгөөд, ХҮН БҮР ӨДӨР БҮР ГЭРТЭЭ АЮУЛГҮЙ ХАРИХ боломжийг ажилчдад олгодог эрсдэлээс хамгаалах процесс юм.

  
![](http://webnew.barloworld.mn/images/uploads2/2020-12-15-05-44-02wae_Picture8.jpg)`,
  },
  {
    id: 3,
    title: "trimble",
    handle: "/technology/trimble",
    image: "https://d3leeb4r1qy96s.cloudfront.net/pages/Technology_3_Trimble.jpg",
    youtube:
      '<iframe width="100%" height="490" src="https://www.youtube.com/embed/7N67uuLaPwc?wmode=transparent" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>',
    content: `### Барилгын технологи

![](http://webnew.barloworld.mn/images/uploads2/2020-09-22-01-38-38wae_Picture1.jpg) Бид Зам, барилгын ажил гүйцэтгэгч нарт хамгийн найдвартай, бат бөх, олон улсын стандартад нийцсэн дэвшилтэт технологиуд болох:  

*   Машин удирдлагын системийн цогц шийдлүүд
*   Байршил тогтоох систем буюу хэмжилтийн багаж
*   Замын ажлын төлөвлөлтийн програм хангамж
*   Жин хэмжүүрийн систем зэрэг олон төрлийн цогц шийдлүүдийг санал болгож байна

Бид дээрх системүүдийг нийлүүлээд зогсохгүй салбарынханд нэн хэрэгцээтэй, ажил хялбаршуулах, зардал бууруулах, хугацаа хэмнэх, чанар, аюулгүй байдлыг дээшлүүлэх, ажлын талбарт тохиромжтой технологийн шийдлийн зөвлөгөө өгч, сургалт зохион байгуулж ажилладаг. Бидний санал болгож буй шалгарсан технологууд Монгол орны нөхцөлд ажлын бүтээмжийг 50-70% нэмэгдүүлж байгаа нь тогтоогдсон юм.  

### Машин удирдлагын систем

![](http://webnew.barloworld.mn/images/uploads2/2020-09-22-01-41-44wae_Picture2.jpg)  

Trimble 2D болон 3D Машин удирдлагын системүүд – Автогрейдр, бульдозер, экскаватор, доргиурт индүү, асфальт дэвсэгч зэрэг олон төрлийн машин техникүүдэд зориулагдсан автоматжуулалтын систем бөгөөд тэгшилгээ хийх ажлын гадаслах процессийг бүр мөсөн халж, операторын таамгаар хийдэг ажлууд ба хэрэглэгдэх материалын хэмжээг эрс багасгаж, хөдөлмөрийн бүтээмжийг нэмэгдүүлж, илүү өндөр ашигтай ажиллах боломжийг бүрдүүлдэг. Өөрөөр хэлбэл зардал мөнгө, цаг хугацаа, хүн хүчийг бууруулж, ажлын чанар болон аюулгүй ажиллагааг нэмэгдүүлдэг.

### Байршил тогтоох систем

![](http://webnew.barloworld.mn/images/uploads2/2020-09-22-01-41-49wae_Picture3.jpg)  

SPS /Замын хэмжилтийн GPS төхөөрөмж/ - Дэлхийн хамгийн бат бөх, найдвартай, өндөр нарийвчлалтай хэмжилтийн төхөөрөмж бөгөөд байршил тогтоож, замын хэмжилт зураглал, геодезийн хэмжилтийн ажилд ашиглагддаг, хэрэглэхэд хялбар систем юм. Мөн Монгол, Орос, Хятад, Англи зэрэг олон хэл дээр ашиглах боломжтой.

### Замын ажлын төлөвлөлтийн програм хангамж

![](http://webnew.barloworld.mn/images/uploads2/2020-09-22-01-42-55wae_Picture6.jpg)  

Замын зураг боловсруулалт болон төслийн төлөвлөлтөөс гүйцэтгэл хүртэл хэрэглэгдэх цогц програм хангамж.

  

### LOADRITE® /жин хэмжүүрийн систем/

![](http://webnew.barloworld.mn/images/uploads2/2020-09-22-01-41-55wae_Picture5.jpg)  

Дугуйт ачигч, экскаватор, туузан дамжуулагч, хүнд даацийн зөөврийн машин зэргийн ачилтыг хянаж, +-1 хүртэлх %-ийн нарийвчлалтайгаар жинлэлтийг хянана.  
  
Trimble®-ийн эдгээр дэвшилтэт технологиудыг 2012 оноос хойш өдгөө Монголын зам болон дэд бүтцийн 10 гаруй томоохон төслүүд дээр үр бүтээлтэй ашиглаж байгаа бөгөөд нийт 700 гаруй км урт замыг эдгээр технологиудын тусламжтайгаар барьсан байна. Түүнчлэн эдгээр технологийн шийдлүүд нь ажлын бүтээмжийг 50-70% нэмэгдүүлдэг юм.  
  
[Брошюр үзэх](https://www.barloworld.mn/uploads/Technology/Load_Rite _Product_brochure.pdf)`,
  },
  {
    id: 4,
    title: "metro",
    handle: "/technology/metro",
    image: "https://d3leeb4r1qy96s.cloudfront.net/pages/Technology_4_Metrology.jpg",
    youtube:
      '<iframe width="100%" height="490" src="https://www.youtube.com/embed/YwtmA4uUbSc?wmode=transparent" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>',
    content: `### Багажны тохиргоо

![](http://webnew.barloworld.mn/images/uploads2/2020-09-22-01-18-10wae_Picture1.jpg)  

Машин тоног төхөөрөмжийн эд ангийн чангалгаа нь тохирсон хэмжээнд байх нь маш чухал ба чангалгаа хэт чанга байх нь хугарах, гулзайх, чангалгаа хэт бага байх нь тухайн эд ангийн холбоосыг мултарч, сулрах, гээгдэх аюулд хүргэдэг.  
  
Вагнер Ази Тоног Төхөөрөмж компани нь багажны дахин тохируулгын үйлчилгээг Монголд анх удаа нэвтрүүлсэн ба Oлон улсын ISO-6789 стандартын дагуу AНУ-д үйлдвэрлэгдсэн өндөр нарийвчлал бүхий орчин үеийн дэвшилт технологиор хийгдсэн Motorized loader TTC2800-загварын хэмжилт тохиргооны багажаар 99.75% нарийвчлалтайгаар хэмжилт тохируулга хийж байна. Мэргэжлийн операторууд чанарын өндөр түвшинд 1-2000 ft-lb хүртэлх хэмжээтэй чангалгааны багажинд тохируулга үйлчилгээ хийдэг.`,
  },
];
